import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { examineNoRule, examineNoRemarkRule, examineRule } from './../utils';
import { uploadFile } from './../../../customer/applicationManage/request';
// import {cryptoDecrypt} from '@/utils/aes';
// import {getBase64} from '@/utils/validate';
import { claimsApprove } from './../../../examine/claimRecordManage/request';
export default {
  data() {
    return {
      action: uploadFile,
      previewVisible: false,
      previewImgVisible: false,
      previewImage: '',
      dataFrom: {},
      nodeId: '',
      fileList: [],
      claimsInfo: {}
    };
  },
  computed: {
    dataRule() {
      return {
        status: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('审核结果')
        }]
      };
    }
  },
  methods: {
    init(id, info) {
      let infoData = JSON.parse(info);
      const claimsDocument = infoData.claimsDocument.map(item => {
        let uploadUrl = item.documentUrl.map(file => {
          return file.url;
        });
        let templateUrl = item.documentTemplateUrl.map(item2 => {
          return item2.url;
        });
        //
        item.documentUrl = uploadUrl;
        item.documentTemplateUrl = templateUrl;
        return item;
      });
      infoData.claimsDocument = claimsDocument;
      this.claimsInfo = infoData;
      console.log(claimsDocument, 22);
      this.nodeId = id;
      this.previewVisible = true;
    },
    statusChange() {
      this.dataFrom.isReplenish = this.dataFrom.status == 5 ? 1 : 0;
      this.dataRule = this.dataFrom.status == 5 ? examineNoRule : this.dataFrom.status == 3 ? examineRule : examineNoRemarkRule;
    },
    handleSure() {
      const h = this.$createElement;
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          this.dataFrom.nodeId = this.nodeId;
          this.claimsInfo.claimsDocument.map(item => {
            delete item.auditOpinion2;
            return item;
          });
          this.claimsInfo.claimsSort.map(item => {
            delete item.auditOpinion2;
            return item;
          });
          this.dataFrom.claimsContent = JSON.stringify(this.claimsInfo);
          await claimsApprove(this.dataFrom);
          if (this.dataFrom.isMailing == 1 && this.dataFrom.status == 3) {
            this.$success({
              title: this.$t('审核成功'),
              content: h("div", [h("p", [this.$t('请前往理赔记录配置邮寄收件地址等信息')])])
            });
          } else if (this.dataFrom.isMailing == 0 && (this.dataFrom.status == 3 || this.dataFrom.status == 4)) {
            this.$success({
              title: this.$t('审核成功'),
              content: h("div", [h("p", [this.$t('请前往理赔记录结案该数据')])])
            });
          } else {
            this.$message.success(this.$t('审核成功'));
          }
          this.$emit('ok');
          this.$emit('cancel');
        }
      });
    }
    // handleChange(info) {
    //   if (info.file.status === 'done') {
    //     if(info.file.response.code!=200){
    //       this.$message.error(info.file.response.message);
    //       this.fileList[this.fileList.length-1].status='error';
    //     }
    //   }
    //   this.dataFrom.picture=[];
    //   this.fileList = info.fileList.map(file => {
    //     if (file.response) {
    //       file.url =process.env.NODE_ENV === 'production'?cryptoDecrypt(file.response.data).fileTempUrl:file.response.data.fileTempUrl;
    //       this.dataFrom.picture.push(file.url);
    //     }
    //     return file;
    //   });
    // },
    // async handlePreview(file) {
    //   if (!file.url && !file.preview) {
    //     file.preview = await getBase64(file.originFileObj);
    //   }
    //   this.previewImage = file.url || file.preview;
    //   this.previewImgVisible = true;
    // }
  }
};